import { FC, useState } from "react";
import {
  Box,
  CardHeader,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
} from "@mui/material";
import { FiX } from "react-icons/fi";
import { useScreenSize } from "../../hooks/useScreenSize";

interface Props {
  open: boolean;
  onClose: () => void;
  paymentURL: string;
}

export const PaymentDialog: FC<Props> = ({ open, onClose, paymentURL }) => {
  const [loading, setLoading] = useState(true);
  const { isMobile } = useScreenSize();

  return (
    <Dialog fullScreen={isMobile} onClose={onClose} open={open} disablePortal>
      <DialogTitle id="alert-dialog-title">
        <CardHeader
          title="Payment"
          sx={{ p: 0 }}
          action={
            <IconButton onClick={onClose}>
              <FiX />
            </IconButton>
          }
        />
      </DialogTitle>
      <DialogContent
        sx={{
          p: 0,
          overflowY: "hidden",
          width: { lg: "500px" },
          height: { lg: "80vh" },
        }}>
        {loading && (
          <Box
            sx={{ width: "100%", height: "100%" }}
            display="flex"
            alignItems="center"
            justifyContent="center">
            <CircularProgress size={50} />
          </Box>
        )}
        <iframe
          width="100%"
          height="100%"
          src={paymentURL}
          onLoad={() => setLoading(false)}
          frameBorder={0}
          allowFullScreen></iframe>
      </DialogContent>
    </Dialog>
  );
};
